import { getListOfUsers } from "../types/account_users_types";

export const getListOfUsersRequest = (payload, cb) => ({
  type: getListOfUsers.GET_LIST_OF_USERS_REQUEST,
  payload,
  cb,
});
export const getListOfUsersSuccess = (payload) => ({
  type: getListOfUsers.GET_LIST_OF_USERS_SUCCESS,
  payload,
});
export const getListOfUsersError = (payload) => ({
  type: getListOfUsers.GET_LIST_OF_USERS_ERROR,
  payload,
});
